<script setup lang="ts">
import { ref, watch, onMounted } from 'vue';
import { PanchImages } from '@/assets/ts/PanchImages';

const props = defineProps<{
  diamond: {
    image_url?: string;
    form: string;
    certificate?: string;
  };
  alert?: boolean;
}>();

const panchImageUrl = ref('');

const checkPanchImage = async () => {
  if (!props.diamond.image_url && props.diamond.certificate) {
    const panch = new PanchImages();
    panchImageUrl.value = (await panch.getStill(props.diamond.certificate)) as string;
  } else {
    panchImageUrl.value = '';
  }
};

onMounted(checkPanchImage);
watch(() => props.diamond, checkPanchImage, { deep: true });

const getLocalImage = (form: string, size: string) => {
  return (process.env.VUE_APP_HOST || "") + "/img/diamonds/cuts/cut_" + form.toLowerCase() + "@" + size + ".jpg";
};
</script>

<template>
  <div class="relative inset-0 w-full h-full aspect-4/3 overflow-auto">
    <img
      :src="diamond.image_url || panchImageUrl || getLocalImage(diamond.form, '1x')"
      :srcset="(!diamond.image_url && !panchImageUrl) ? `${getLocalImage(diamond.form, '1x')} 1x, ${getLocalImage(diamond.form, '2x')} 2x` : undefined"
      alt="Diamond"
      class="w-full h-full object-cover"
      :class="!diamond.image_url && !panchImageUrl ? 'object-center' : 'object-bottom'"
    />
    <div
      v-if="!diamond.image_url && !panchImageUrl && alert !== false"
      class="absolute bottom-2 left-1/2 -translate-x-1/2 rounded-lg bg-brand-main/60 px-2 py-0.5 text-[8px] uppercase tracking-widest text-white z-10"
    >
      Beispielabbildung
    </div>
  </div>
</template>
